import api from './api';

const serviceMasterService = {
  getAllServices: async (params = {}) => {
    try {
      const response = await api.get('/service-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all service master records:', error);
      throw error;
    }
  },

  getServiceById: async (id) => {
    try {
      const response = await api.get(`/service-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching service master record with ID ${id}:`, error);
      throw error;
    }
  },

  createService: async (serviceData) => {
    try {
      const response = await api.post('/service-master', serviceData);
      return response.data;
    } catch (error) {
      console.error('Error creating service master record:', error);
      throw error;
    }
  },

  updateService: async (id, serviceData) => {
    try {
      const response = await api.put(`/service-master/${id}`, serviceData);
      return response.data;
    } catch (error) {
      console.error(`Error updating service master record with ID ${id}:`, error);
      throw error;
    }
  },

  deleteService: async (id) => {
    try {
      const response = await api.delete(`/service-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting service master record with ID ${id}:`, error);
      throw error;
    }
  },

  getServiceStats: async () => {
    try {
      const response = await api.get('/service-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching service master stats:', error);
      throw error;
    }
  },

  getServicesBySAC: async (sacCode) => {
    try {
      const response = await api.get(`/service-master/sac/${sacCode}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching services by SAC ${sacCode}:`, error);
      throw error;
    }
  },

  getActiveServices: async () => {
    try {
      const response = await api.get('/service-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active services:', error);
      throw error;
    }
  },
};

export default serviceMasterService;
